require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-does-the-world-need-from-the-world-bank-on-climate.json") })
        }
      }, "path---en-us-update-what-does-the-world-need-from-the-world-bank-on-climate");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-does-the-world-need-from-the-world-bank-on-climate!./.cache/json/en-us-update-what-does-the-world-need-from-the-world-bank-on-climate.json
// module id = 838
// module chunks = 231608221292675